/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_MoreInputs */



/**
* | output |
* | --- |
* | "More" |
*
* @param {Common_MoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_more = /** @type {((inputs?: Common_MoreInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_MoreInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plus")
	if (locale === "es") return /** @type {LocalizedString} */ ("Más")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Altro")
	return /** @type {LocalizedString} */ ("More")
});